import { GET_STUDIOS } from "constants/studios";

export default (state = null, action) => {
  switch (action.type) {
    case `${GET_STUDIOS}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
